module.exports = __webpack_public_path__ + "media/en_us_s4_Pamela.3997372e.oga";